// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

import { Application } from "@hotwired/stimulus"
import SearchResultsController from "../controllers/search_results_controller"

window.Stimulus = Application.start()
Stimulus.register("search-results", SearchResultsController)
